module.exports = __webpack_public_path__ + "img/cresc_top.86c27e34.jpg";